export default __webpack_public_path__ + "static/media/text-my-nft.b8cda5d0.svg";